export const pspDTO = data => {
  return data.data
}
